import { Vue, Component, Prop } from 'vue-property-decorator'
import { format } from 'fecha'
import Stock from '~/types/api/stock/Stock'
import ArrowSvg from '~/assets/svg/arrow-search.svg?inline'
import loc from '~/utils/loc'
import SfImageElement from '~/components/element/SfImageElement'

@Component
export default class StockCard extends Vue {
  @Prop({ required: true, type: Object })
  readonly stock!: Stock;

  get dateStart (): string | undefined {
    if (this.stock.dateFrom) {
      return this.formatDate(new Date(this.stock.dateFrom))
    }
  }

  get dateEnd (): string | undefined {
    if (this.stock.dateTo) {
      return this.formatDate(new Date(this.stock.dateTo))
    }
  }

  get date (): string | undefined {
    if (this.dateEnd && this.dateStart) {
      return `с ${this.dateStart} по ${this.dateEnd}`
    } else if (this.dateStart) {
      return `с ${this.dateStart}`
    } else if (this.dateEnd) {
      return `по ${this.dateEnd}`
    }
  }

  get location () {
    return loc(this.$store, {
      name: 'stock-code',
      params: {
        code: this.stock.code
      }
    })
  }

  formatDate (date: Date) {
    const intl = new Intl.DateTimeFormat('ru-RU', {
      month: 'long'
    })

    let month = intl.format(date)
    const lastChar = month.charAt(month.length - 1)

    if (lastChar === 'ь' || lastChar === 'й') {
      month = month.substring(0, month.length - 1)
      month += 'я'
    } else {
      month += 'а'
    }

    const day = format(date, 'D')

    return `${day} ${month}`
  }

  render () {
    return (
      <div
        {...{
          class: 'stock-card',
          on: {
            click: () => this.$router.push(this.location)
          }
        }}
      >
        <div class="stock-card__col-content">
          <nuxt-link to={this.location} class="stock-card__title">
            {this.stock.title}
          </nuxt-link>

          <div class="stock-card__col-image">
            <nuxt-link to={this.location} class="stock-card__image">
              <SfImageElement
                {...{
                  props: {
                    img: this.stock.slideImage ? this.stock.slideImage : this.stock.image
                  }
                }}
              />
            </nuxt-link>
          </div>
        </div>
      </div>
    )
  }
}
